export default 'reportTemplate'
